/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attachment': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" d="M8.25 3.818L4.298 7.765a1.73 1.73 0 0 1-2.464 0c-.672-.688-.688-1.79 0-2.461l4.256-4.25a1.073 1.073 0 0 1 1.536 0c.416.431.432 1.118 0 1.534L3.978 6.23a.435.435 0 0 1-.624 0 .434.434 0 0 1 0-.624l3.328-3.323-.464-.463-3.312 3.323a1.07 1.07 0 0 0 0 1.534c.432.431 1.12.431 1.536 0L8.09 3.035a1.725 1.725 0 0 0 0-2.46c-.688-.672-1.792-.688-2.464 0L1.354 4.84a2.38 2.38 0 0 0 0 3.387 2.388 2.388 0 0 0 3.392 0L8.698 4.28l-.448-.463z" _fill="#404040" fill-rule="nonzero"/>'
  }
})
